<template>
  <div>
        <MasterHeader
        v-bind:classHeader="'registration deleteAccount'"
        v-bind:classGrid="'wp800'"/>
    <section>
      <!-- delete account step 2 -->
      <div class="deleteProfile step2 popUp wp800">
        <div class="flex">
          <img src="@/assets/images/alertIcon.svg" class="mainImageWindow"/>
          <div class="rightText">
            <h3>{{ $t("delete_profile.step3_title") }}</h3>
            <p>{{ $t("delete_profile.step3_text") }}</p>
            <a v-on:click="successDelete()" class="txt">{{ $t("delete_profile.step3_link") }}</a><br>
            <a v-on:click="abortDelete()" class="txt">{{ $t("delete_profile.step3_link2") }}</a>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>
<script>
import MasterHeader from './partials/MasterHeader';
export default {
  components:{
    MasterHeader
  },
  created() {
    this.validateToken();
  },
  methods:{
    validateToken(){
      this.$http
          .post("api/v1/validateDeleteAccountToken",{
            token: this.$route.params.token,
          }).then().catch((e)=>{
        this.$router.replace({ name: "account-delete-fail" });
      })
    },
    successDelete(){
      this.$http
          .post("api/v1/deleteAccount",{
            token: this.$route.params.token,
          })
          .then(() => {
            this.$store.dispatch("user/logout");
            this.$router.replace({ name: "delete-account-success" });
          })
          .catch((e) => {
            this.$router.replace({ name: "account-delete-fail" });
          });
    },
    abortDelete(){
      this.$router.replace({ name: "delete-account-abort" });
    }
  }
};
</script>
<style scoped>
.deleteProfile a{
  cursor: pointer;
}
</style>